module.exports = __webpack_public_path__ + "media/images/alex-by-admired-leadership-af64fed5.svg";